export enum RouterPathEnum {
    FirstPage = "/",
    Profile = "/profile",
    CharacterChoice = "/profile/characterChoice",
    Almanac = "/profile/almanac",
    SceneMuscle = "/profile/scenemuscle",
    SceneMap = "/profile/scenemap",
    SceneCognitive = "/profile/scenecognitive",
    ScenePage4 = "/profile/scenepagear",
    SceneWear = "/profile/scenewear",
    SceneFineMotor = "/profile/scenefinemotor",
    FineMotor = "/profile/fine-motor",
    ScenePage5 = "/profile/scenepage5",
    ScenePage6 = "/profile/scenepage6",
    ScenePage7 = "/profile/scenepage7",
    ScenePage8 = "/profile/scenepage8",
    HeartRateDashboard = "/profile/heart-rate/:category",
    HeartRateFunctional = "/profile/heart-rate/functional",
    HeartRateRunning = "/profile/heart-rate/running",
    HeartRateShort = "/profile/heart-rate/short",
    BreathingAssessment = "/profile/breathing",
    BreathingSpirometry = "/profile/breathing/spirometry",
    BreathingInterworld = "/profile/breathing/interworld",
    BreathingSpirometrySession = "/profile/breathing/spirometry/session/:sessionId",
    BreathingInterworldSession = "/profile/breathing/interworld/session/:sessionId",
    Dashboard = "/profile/dashboard",
    DoctorPage = "/profile/doctor",
    CreateCharacterPage = "/profile/create-character",
    KBGU = "/profile/kbgu",
    Metabolism = "/profile/metabolism",
    Psychology = "/profile/psychology",
    UserParameters = "/profile/user-parameters",
    Auth = "/auth",
    RegistrationPage = "/register",
    KeyLost = "/keylost",
    Explanation = "/explanation",
    Routing = "/routing",
    Rankings = "/profile/rankings/:gameType",
}

export enum DragNDropEvents {
    DragEnter = "dragenter",
    DragLeave = "dragleave",
    DragOver = "dragover",
    Drop = "drop",
}
